import Editor from 'components/form/fields/Editor/Editor';
import TextInput from 'components/form/fields/TextInput/TextInput';
import { slugNormalizer } from 'core/helpers/normalizers';
import Checkbox from '../../../components/form/fields/Checkbox/Checkbox';
import createDecorator from 'final-form-calculate';
import { toast } from 'react-toastify';
import { createSelector } from 'reselect';
import { checkSlugs } from './redux';

export const gridConfig = {
  columns: [
    {
      name: 'name',
      title: 'Name',
    },
    {
      name: 'slug',
      title: 'Slug',
    },
  ],
  title: 'Hashtags',
};

export const formConfig = {
  fields: [
    { name: 'name', title: 'Name', component: TextInput, isRequired: true },
    {
      component: TextInput,
      isRequired: true,
      name: 'slug',
      normalizer: slugNormalizer,
      title: 'Slug',
    },
    {
      component: Checkbox,
      name: 'isSlugNotSynchronized',
      title: 'Do not synchronize the slug and the title',
    },
    {
      component: Editor,
      name: 'description',
      title: 'Description',
    },
  ],
  title: 'Hashtag',
};

const slugsDecorator = (initialValues: any) =>
  createDecorator(
    {
      field: 'name',
      updates: {
        slug: async (
          value: string,
          allValues: any,
          prevValues: any,
        ): Promise<string> => {
          const slug =
            allValues.isSlugNotSynchronized ||
            !prevValues.hasOwnProperty('slug')
              ? allValues.slug
              : await slugNormalizer(value);

          if (slug === initialValues.slug) {
            return slug;
          }
          try {
            const { data } = await checkSlugs(slug);

            if (Array.isArray(data)) {
              return data[0];
            }
          } catch (error) {
            if (error.message !== '404') {
              toast.error(error.message);
            }
          }

          return slug;
        },
      },
    },
    {
      field: 'isSlugNotSynchronized',
      updates: {
        slug: (value: string, allValues: any): string => {
          return value ? allValues.slug : slugNormalizer(allValues.name);
        },
      },
    },
  );

export const decorators = createSelector(
  initialValues => initialValues,
  (initialValues: any) => [slugsDecorator(initialValues)],
);
